<template>
  <div class="j_datagrid_title">
    <div>
      <div v-if="attrs.main" :style="titleWrapStyle">
        <h5 :style="titleMainStyle">{{ titleMain }}</h5>
        <small v-if="titleSub" :style="titleSubStyle">{{ titleSub }}</small>
      </div>
      <div>
        <pre v-if="titleData" :style="titleDataStyle">{{ titleData }}</pre>
      </div>
      <div>
        <pre v-if="noteText" :style="noteStyle">{{ noteText }}</pre>
      </div>
      <div v-if="legendVisible && legendItemsFlatten.length" :style="legendWrapStyle">
        <div 
          v-for="(item, idx) in legendItemsFlatten"
          :key="idx"
          :style="getLegendItemStyle(item)"
          >
          {{ item.text || item.code }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import __C from '../../../../src/primitives/_constant_'
import '../../../../src/assets/stylus/ui/component/_jDatagridTitle.scss'

import { VIcon, VCol } from 'vuetify/components'

export default {
  name: 'j-data-grid-title',
  components: {
    VIcon,
    VCol,
  },
  props: {
    sideslide: Boolean,
    attrs: { type: Object, default: () => ({}) },
    legendItems: { type: Object, default: () => null },
    chartData: null,
  },
  data() {
    return {
    }
  },
  computed: {
    titleWrapStyle() {
      return {
        display: 'flex',
        alignItems: 'flex-end',
      }
    },
    titleMain() {
      return this.attrs.main ? this.attrs.main.text : ''
    },
    titleMainStyle() {
      if (!this.attrs.main) return {}
      return {
        fontFamily: this.attrs.main.font,
        fontSize: `${this.attrs.main.fontSize}px`,
        color: this.sideslide ? '#2196f3' : this.attrs.main.color,
        marginRight: '7px',
      }
    },
    titleSub() {
      return this.attrs.sub ? this.attrs.sub.text : ''
    },
    titleSubStyle() {
      if (!this.attrs.sub) return {}
      return {
        fontFamily: this.attrs.sub.font,
        fontSize: `${this.attrs.sub.fontSize}px`,
        color: this.attrs.sub.color,
        marginBottom: '2px',
      }
    },
    titleData1() { return this.attrs.queries ? this.attrs.queries._1st : '' },
    titleData2() { return this.attrs.queries ? this.attrs.queries._2nd : '' },
    titleData3() { return this.attrs.queries ? this.attrs.queries._3rd : '' },
    titleData4() { return this.attrs.queries ? this.attrs.queries._4th : '' },
    titleData5() { return this.attrs.queries ? this.attrs.queries._5th : '' },
    titleData() {
      return [
        this.titleData1,
        this.titleData2,
        this.titleData3,
        this.titleData4,
        this.titleData5,
      ]
        .filter(Boolean)
        .join('')
    },
    titleDataStyle() {
      if (!this.attrs.query) return {}
      return {
        fontFamily: this.attrs.query.font,
        fontSize: `${this.attrs.query.fontSize}px`,
        color: this.attrs.query.color,
        paddingBottom: '7px',
      }
    },

    // ----- Note -----
    noteText() {
      return this.attrs.note?.text || ''
    },
    noteStyle() {
      // 원본 코드에서 this.attrs.sub 체크하던 버그는 this.attrs.note 기준으로 수정
      if (!this.attrs.note) return {}
      return {
        fontFamily: this.attrs.note.font,
        fontSize: `${this.attrs.note.fontSize}px`,
        color: this.attrs.note.color,
        paddingBottom: '7px',
      }
    },

    // ----- Legend -----
    legendVisible() {
      return this.attrs.showLegend === 'Y' && !!this.legendItems
    },
    legendItemsFlatten() {
      if (!this.legendVisible) return []
      const propNames = ['cell', 'color', 'text']
      const result = []
      propNames.forEach((name) => {
        const arr = this.legendItems[name] || []
        arr.forEach((item) => {
          result.push({
            ...item,
            _type: name, // cell / color / text 구분용
          })
        })
      })
      return result
    },
    legendWrapStyle() {
      return {
        display: 'flex',
        lineHeight: '1.4rem',
        paddingBottom: '7px',
      }
    },

  },
  watch: {
  },
  methods: {
    // Legend item 스타일
    getLegendItemStyle(item) {
      const style = {
        color: item.tColor,
        paddingLeft: '1rem',
        paddingRight: '1rem',
        marginRight: '1rem',
      }

      if (item._type === 'cell') {
        style.background = `linear-gradient(to right, ${item.bColor} 50%, #fff 50%)`
      } else if (item._type === 'color') {
        style.backgroundColor = item.bColor
      } else {
        style.paddingLeft = '3px'
        style.paddingRight = '3px'
      }

      return style
    },

  },
}
</script>
